import { surfaces } from '@ui/kit/design-tokens';
import { combineTokens } from '@utils/css';

combineTokens("--universal-harmonica-card", {
  badgeSurface: surfaces.accent.default
});
const wrapper = "_araw4rmin5";
const contextMenu = "_arac14w5ypn";
const button = "_arab1d1wslh";
const checkmark = "_arac6xo12n";
const badgeWrapperCls = "_arab1y8xzfi";
const badgeImageCls = "_arabs7mkeu";
const indexBadgeCls = "_arai1ur6z9c";
const headerWrapperCls = "_arahnwfk9z";
const headerTextCls = "_arah1w7juyj";
const expandCls = "_araebr9zd";
const iconWrapperCls = "_arai4vebn7";

// Static description wrapper which is displayed while the component is
// collapsed
const descriptionWrapperCls = "_arad1g9qo89";
const descriptionCls = "_aradqjy852";

export { badgeImageCls, badgeWrapperCls, button, checkmark, contextMenu, descriptionCls, descriptionWrapperCls, expandCls, headerTextCls, headerWrapperCls, iconWrapperCls, indexBadgeCls, wrapper };
import "./harmonica.card.style.linaria.module.css";
//# sourceMappingURL=harmonica.card.style.js.map
